const eye_color_list = {
    BLUE_EYE_COLOR:           0,
    GREY_EYE_COLOR:           1,
    GREEN_EYE_COLOR:          2,
    HAZEL_EYE_COLOR:          3,
    BLACK_EYE_COLOR:          4,
    BROWN_EYE_COLOR:          5,
    HETEROCHROMIA_EYE_COLOR:  6,
    RED_EYE_COLOR:            7
}

const hair_color_list = {
    BLOND_HAIR_COLOR:         0,
    DARK_BLOND_HAIR_COLOR:    1,
    BROWN_HAIR_COLOR:         2,
    BLACK_HAIR_COLOR:         3,
    CHESTNUT_HAIR_COLOR:      4,
    RED_HAIR_COLOR:           5,
    ALBINISM_HAIR_COLOR:      6
}

const hair_shape_list = {
    STRAIGHT_HAIR_SHAPE:      0,
    WAVE_HAIR_SHAPE:          1,
    CURLY_HAIR_SHAPE:         2
}

const body_type_list = {
    ECTOMORPH_BODY_TYPE:      0,
    MESOMORPH_BODY_TYPE:      1,
    ENDOMORPH_BODY_TYPE:      2
}

export {eye_color_list, hair_color_list, hair_shape_list, body_type_list}